import React from 'react';
import { Box, Typography, Grid, IconButton, Link, Button } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import InstagramIcon from '@mui/icons-material/Instagram';

const Footer = () => {
  const whatsappNumber = "447927052198"; // No spaces or symbols for wa.me link
  const formattedNumber = "+44 7927 052198";

  return (
    <Box
      sx={{
        backgroundColor: '#0c0c0c',
        borderTop: '2px solid #31F711',
        pt: 6,
        pb: 4,
        position: 'relative',
        zIndex: 1,
        mt: 8,
      }}
    >
      <Box className="container">
        <Grid container spacing={4} justifyContent="space-between">
          {/* Logo/Name Section */}
          <Grid item xs={12} md={4}>
            <Typography variant="h5" sx={{ color: '#31F711', fontWeight: 'bold', mb: 2 }}>
              HAFEEZ ATIF
            </Typography>
            <Typography variant="body2" sx={{ color: '#aaa', lineHeight: 1.8 }}>
              A passionate MERN Stack & Mobile App Developer focusing on creating high-performance web and mobile applications with clean and structured code.
            </Typography>
          </Grid>

          {/* Quick Links Section */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" sx={{ color: '#31F711', fontWeight: 'bold', mb: 2 }}>
              Quick Links
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link href="#" sx={{ color: '#aaa', textDecoration: 'none', '&:hover': { color: '#31F711' } }}>
                Introduction
              </Link>
              <Link href="https://www.linkedin.com/in/hafeez-atif-2005h/" target="_blank" sx={{ color: '#aaa', textDecoration: 'none', '&:hover': { color: '#31F711' } }}>
                LinkedIn
              </Link>
              <Link href="https://github.com/Hafeezdeveloper" target="_blank" sx={{ color: '#aaa', textDecoration: 'none', '&:hover': { color: '#31F711' } }}>
                GitHub
              </Link>
            </Box>
          </Grid>

          {/* Contact Section */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6" sx={{ color: '#31F711', fontWeight: 'bold', mb: 2 }}>
              Contact Me
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              {/* WhatsApp Call to Action */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <PhoneIcon sx={{ color: '#31F711' }} />
                <Typography variant="body2" sx={{ color: '#fff' }}>
                  Call / SMS: {formattedNumber}
                </Typography>
              </Box>

              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <EmailIcon sx={{ color: '#31F711' }} />
                <Typography variant="body2" sx={{ color: '#fff' }}>
                  hafeez.hussain2003@gmail.com
                </Typography>
              </Box>

              <Button
                variant="outlined"
                startIcon={<WhatsAppIcon />}
                href={`https://wa.me/${whatsappNumber}`}
                target="_blank"
                sx={{
                  color: '#31F711',
                  borderColor: '#31F711',
                  fontWeight: 'bold',
                  alignSelf: 'flex-start',
                  px: 3,
                  py: 1,
                  borderRadius: '30px',
                  '&:hover': {
                    backgroundColor: 'rgba(49, 247, 17, 0.1)',
                    borderColor: '#31F711',
                  },
                }}
              >
                Chat on WhatsApp
              </Button>
            </Box>
          </Grid>
        </Grid>

        {/* Divider */}
        <Box sx={{ borderBottom: '1px solid rgba(255, 255, 255, 0.1)', my: 4 }} />

        {/* Footer Bottom */}
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: 'center', gap: 2 }}>
          <Typography variant="body2" sx={{ color: '#666', textAlign: { xs: 'center', sm: 'left' } }}>
            &copy; {new Date().getFullYear()} Hafeez Atif. All rights reserved.
          </Typography>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <IconButton href="https://www.linkedin.com/in/hafeez-atif-2005h/" target="_blank" sx={{ color: '#aaa', '&:hover': { color: '#31F711' } }}>
              <LinkedInIcon />
            </IconButton>
            <IconButton href="https://github.com/Hafeezdeveloper" target="_blank" sx={{ color: '#aaa', '&:hover': { color: '#31F711' } }}>
              <GitHubIcon />
            </IconButton>
            <IconButton href="https://www.instagram.com/hafeezhussaun/" target="_blank" sx={{ color: '#aaa', '&:hover': { color: '#31F711' } }}>
              <InstagramIcon />
            </IconButton>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
